/**
 * Default (Symphona / Novus baseline) values for the tenant configuration.
 *
 * Every default is explicit so that a partial `GET /tenantConfig` response can be
 * safely deep-merged on top — any key the API omits falls back to these values,
 * and a failed fetch leaves the app on the Novus baseline.
 */

import type {
  CustomerThemeOverrides,
  TenantBranding,
  TenantFeatures,
} from '@services/tenantConfig.types';

export const DEFAULT_THEME_OVERRIDES: CustomerThemeOverrides = {
  fontStacks: {
    displayFont: '"Gazpacho Black", "Gazpacho", sans-serif',
    headerFont: '"Agrandir", sans-serif',
    bodyFont: '"Montserrat", "Roboto", sans-serif',
    monoFont: '"Roboto", "Montserrat", sans-serif',
  },
  companyColors: {
    novus: {
      color: '#001884',
      topGradient: { start: '#001884', end: '#0057B8' },
      bottomGradient: { start: '#00B0F0', end: '#BFF2FF' },
    },
  },
  muiOptions: {
    palette: {
      primary: {
        main: '#001884',
        dark: '#001060',
        light: '#0057B8',
        contrastText: '#FFFFFF',
      },
    },
  },
};

export const DEFAULT_BRANDING: TenantBranding = {
  displayName: 'Symphona',
  heroTagline: 'Is Available in Your Building',
  homepageUrl: 'https://www.symphona.ai/',
  portalName: 'Novus',
  bannerTextColor: '#FFFFFF',
  jumbotronTopGradient: { start: '#001884', end: '#0057B8' },
  jumbotronBottomGradient: { start: '#00B0F0', end: '#BFF2FF' },
};

export const DEFAULT_FEATURES: TenantFeatures = {
  useCustomProductOfferings: false,
  useCustomCustomerTable: false,
  useCustomOrderDetails: false,
  enableProductConfigurations: true,
};
